var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDontGiveUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 158,
    viewBox: "0 0 260 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.927 0.999999C249.088 7.41943 236.019 13.2534 223.526 20.3756C204.504 31.2203 186.122 43.7229 169.28 57.7263C164.269 61.8925 159.668 66.8513 153.756 69.8068C151.962 70.704 150.417 72.5919 149 74.0088",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1833 49C16.3997 55.9456 11.5477 76.2776 8.2749 85.4561",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.613 50.9707C25.906 54.6162 31.8754 56.6339 35.1391 62.5514C38.8855 69.344 35.2522 77.7696 31.3019 83.5051C28.0535 88.2217 24.304 89.9379 19.2247 87.8829C15.8391 86.5131 12.1841 85.8361 8.75201 85.3543",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4146 92.0136C37.7067 87.1038 41.2439 77.4686 48.3686 72.929C59.6421 66.7256 62.7486 82.2614 59.6175 90.9206C57.195 97.6204 50.9344 100.852 47.0819 99.2378C44.4706 98.1436 41.9309 94.7628 40.4146 92.0136Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8762 80.4182C67.7114 85.7866 67.7653 87.111 67.4431 92.2421C67.1587 96.771 65.9803 100.791 65.8158 105.308C65.7926 105.944 64.9252 109.383 65.2862 108.859C66.6403 106.893 66.7088 103.477 67.0792 101.097C67.741 96.8451 69.3336 92.3576 71.806 88.7678C73.6987 86.0197 80.4304 79.9687 83.6707 88.9412C86.6302 97.1362 84.5726 108.022 83.3958 113.416",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9271 76.9375C92.8598 79.939 92.1975 83.1889 90.1062 86.2254",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.634 63.4189C111.609 72.1658 106.154 80.4519 102.96 90.6994C101.144 96.525 99.2567 103.096 98.161 109.108C97.9391 110.326 97.0307 113.928 97.0688 113.872",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.948 71.6277C106.286 75.3045 113.172 76.2746 119.226 77.1246",
    stroke: "white",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.389 108.75C129.392 105.842 128.728 103.368 125.791 101.345C123.449 99.732 118.188 106.514 119.551 109.261C121.404 112.996 123.182 112.302 126.404 110.435C127.641 109.718 128.222 108.685 129.028 107.515C129.83 106.35 127.816 110.163 127.807 111.577C127.747 120.219 125.601 128.509 120.702 135.621C119.199 137.804 110.454 140.64 109.651 136.284C108.772 131.513 115.096 125.244 119.054 124.285C125.512 122.72 131.588 119.663 137.877 117.549",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.004 105.222C141.575 108.749 143.325 114.77 142.354 119.058",
    stroke: "white",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.45 98.2383C145.315 99.8862 147.122 99.4568 146.45 98.2383",
    stroke: "white",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.195 104.415C151.491 106.018 152.449 110.404 152.721 112.014C153.161 114.609 153.66 117.105 154.135 119.686C154.468 121.491 154.694 123.277 154.564 125.103C154.402 127.359 155.287 125.45 155.973 124.454C158.712 120.479 162.469 112.12 164.968 108.022",
    stroke: "white",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M173.506 118.449C176.301 120.374 179.481 119.632 182.443 118.694C184.346 118.092 186.806 115.789 184.64 114.297C180.891 111.714 175.204 111.408 172.473 115.373C169.487 119.709 171.924 124.451 176.073 127.308C178.016 128.647 183.832 134.348 185.729 131.595",
    stroke: "white",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M206.332 114.264C203.357 118.583 200.464 122.531 202.949 127.694C203.613 129.075 204.598 130.233 205.43 131.592C207.716 135.325 210.235 130.336 211.497 128.503C213.283 125.91 215.069 123.317 216.855 120.724C219.204 117.314 217.023 120.346 216.49 122.398C215.147 127.565 215.782 132.179 215.705 137.268",
    stroke: "white",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.881 119.061C222.846 123.466 224.898 131.584 224.696 136.544C224.51 141.131 224.597 145.749 224.648 150.345C224.671 152.499 224.025 154.56 224.412 156.662",
    stroke: "white",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.715 118.158C226.688 117.066 232.242 119.502 233.364 120.274C236.276 122.28 238.951 124.65 238.588 128.644C237.995 135.163 233.544 141.143 226.299 139.049",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontGiveUp);
export default __webpack_public_path__ + "static/media/dont-give-up.bab35f71ef09872c22f31511cbc1cb6d.svg";
export { ForwardRef as ReactComponent };